import { render, staticRenderFns } from "./OrderProductTable.vue?vue&type=template&id=4d01b0e9&"
import script from "./OrderProductTable.vue?vue&type=script&lang=js&"
export * from "./OrderProductTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports